// src/plugins/axios.js
import axios from 'axios';
import { getImplementationManagerToken } from './implementationApiTokenManager.js'

export const apiImplementationManager = axios.create({
  baseURL: process.env.VUE_APP_API_IMPLEMENTATIONMANAGER,
  headers: {
    'Content-Type': 'application/json',
  },
});


export const funcGoCardlessMandateManager = axios.create({
  baseURL: process.env.VUE_APP_FUNC_GOCARDLESSMANDATEMANAGER,
  headers: {
    'Content-Type': 'application/json',
  },
});


export const funcCompaniesHouseManager = axios.create({
  baseURL: process.env.VUE_APP_FUNC_COMPANIESHOUSEMANAGER,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const funcClientSignupManager = axios.create({
  baseURL: process.env.VUE_APP_FUNC_CLIENTSIGNUPMANAGER,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const funcBlobStorageCommunicator = axios.create({
  baseURL: process.env.VUE_APP_FUNC_BLOBSTORAGECOMMUNICATOR,
});

export const funcPowerAutomate = axios.create({
  baseURL: process.env.VUE_APP_FUNC_POWERAUTOMATE,
  headers: {
    'Content-Type': 'application/json',
  },
});

apiImplementationManager.interceptors.request.use(
  async (config) => {
    if (config.skipAuth) return config;

    const token = await getImplementationManagerToken();
    config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error)
);

apiImplementationManager.interceptors.response.use(
  response => response,
  error => {
    // Handle global errors here (e.g., logging, toast, redirect)
    console.error('API Error:', error);
    return Promise.reject(error);
  }
);


funcGoCardlessMandateManager.interceptors.response.use(
  response => response,
  error => {
    // Handle global errors here (e.g., logging, toast, redirect)
    console.error('API Error:', error);
    return Promise.reject(error);
  }
);


funcCompaniesHouseManager.interceptors.response.use(
  response => response,
  error => {
    // Handle global errors here (e.g., logging, toast, redirect)
    console.error('API Error:', error);
    return Promise.reject(error);
  }
);


funcClientSignupManager.interceptors.response.use(
  response => response,
  error => {
    // Handle global errors here (e.g., logging, toast, redirect)
    console.error('API Error:', error);
    return Promise.reject(error);
  }
);


funcBlobStorageCommunicator.interceptors.response.use(
  response => response,
  error => {
    // Handle global errors here (e.g., logging, toast, redirect)
    console.error('API Error:', error);
    return Promise.reject(error);
  }
);